import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VideoChatPage} from './video-chat-page/video-chat.page';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {VideoChatRoutingModule} from './video-chat-routing.module';
import {ComponentsModule} from '../components/components.module';
import {TimerComponent} from './components/timer/timer.component';
import {DocumentsComponent} from './components/documents/documents.component';
import {NotesComponent} from './components/notes/notes.component';
import {ChatComponent} from './components/chat/chat.component';
import {SettingUpComponent} from './components/setting-up/setting-up.component';
import {StreamComponent} from './components/stream/stream.component';
import {OpenViduVideoComponent} from './components/stream/ov-video.component';
import {VideoChatCompletePage} from "./video-chat-complete/video-chat-complete.page";
import {FooterLogoComponent} from "../components/footer-logo/footer-logo.component";
import {TimerDialComponent} from "./components/timer-dial/timer-dial.component";
import {TimerCounterComponent} from "./components/timer-counter/timer-counter.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ComponentsModule,
        VideoChatRoutingModule,
        TranslateModule.forChild(),
        NgSelectModule
    ],
    declarations: [
        VideoChatPage,
        VideoChatCompletePage,
        TimerComponent,
        DocumentsComponent,
        NotesComponent,
        ChatComponent,
        SettingUpComponent,
        StreamComponent,
        OpenViduVideoComponent,
        FooterLogoComponent,
        TimerDialComponent,
        TimerCounterComponent
    ],
    exports: [
        FooterLogoComponent
    ],
  entryComponents: [ChatComponent, SettingUpComponent]
})
export class VideoChatModule {
}
